import { Injectable } from '@angular/core';
import { WindowService } from './../window/window.service';
import { CordovaService } from './../cordova/cordova.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LinkService {
  public _window: Window;
  public $subscriber: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    windowRef: WindowService,
    private cordova: CordovaService,
  ) {
    this._window = windowRef.nativeWindow;
  }

  openLink(url: any): void {
    if (this.cordova.isApp()) {
      const message = {
        action: 'browse',
        url: url,
        target: '_system',
        options: 'locations=yes,toolbar=no,clearcache=yes',
      };
      this._window.parent.postMessage(message, '*');
    } else {
      this._window.open(url, '_blank');
    }
  }

  async openRedirect(url: any) {
    return;
  }

  // No-op by default (matching openRedirect above) — overridden per-app where an
  // in-app browser is actually opened, so a deep-link return can close it.
  closeOpenBrowser(): void {
    return;
  }

  normalizeUrl(url: string) {
    return url;
  }

  watchQueryParams(): BehaviorSubject<any> {
    return this.$subscriber;
  }

  clearQueryParams(): void {
    this.$subscriber.next(null);
  }
}
